import { UserStore } from "../../auth/model/UserStore";
import { AuthState } from "../../auth/AuthState";
export class UserStateQualifier {
    constructor() {
        this.key = "UserState";
    }
    process() {
        const user = UserStore.getUser();
        // If user data is loaded and has a UserState, use it
        if ((user === null || user === void 0 ? void 0 : user.UserState) && user.UserState !== '') {
            return user.UserState;
        }
        // Fall back to AuthState — set by Auth0 session restore/login
        // even if UserService.syncUser() hasn't completed yet
        if (AuthState.isAuthenticated) {
            return "LoggedIn";
        }
        return "LoggedOut";
    }
}
